export enum BorderColor {
    Red = 'red',
    Green = 'green',
    Yellow = 'yellow',
    Magenta = 'magenta',
    Cyan = 'cyan',
    Blue = 'blue',
    Default = 'default'
}

export enum TextColor {
    Red = 'red',
    Green = 'green',
    Yellow = 'yellow',
    Magenta = 'magenta',
    Cyan = 'cyan',
    Blue = 'blue',
    Main = 'main',
    Sub = 'sub'
}

export enum TextVariant {
    Accent = 'accent',
    Title = 'title',
    Body = 'body'
}

export enum TextSize {
    XXSmall = 'xxs',
    XSmall = 'xs',
    Small = 's',
    Medium = 'm',
    Large = 'l',
    XLarge = 'xl',
    XXLarge = 'xxl'
}
